<div class="container-fluid">

  <div class="row">

      <div class=" parent col-12" style="margin-left: -18px;margin-top:0px ;  padding:100px;width: 90%;padding-bottom: 50px;height: 70%; ">
        <div class="rounded-lg" style="background: white;"  >

          <div class="row">

              <div class="col-5" >
               <div style="margin-top: 30px; margin-left: 20px;">
                <input type="hidden" id="anPageName" name="page" value="contact-us" />
                            <div class="form-group col-md-4">
                              <span>Name<a class="red-asterik">*</a></span>
                              <input type="text" [(ngModel)]="Name"  class="form-control input-sm purpleInput" />
                            </div>
          
                            <div class="form-group col-md-4">
                              <!-- <label style="color: #3F33FF">Last name</label> -->
                              <span >Last Name<a class="red-asterik">*</a></span>
                              <input type="text" [(ngModel)]="LastName" class="form-control input-sm purpleInput"/>
                            </div> 
           
                            <div class="form-group col-md-4">
                              <!-- <label style="color: #3F33FF">Email</label> -->
                              <span> Email<a class="red-asterik">*</a></span>
                              <input type="text" [(ngModel)]="Email"  class="form-control input-sm purpleInput" />
                            </div> 
          
                            <div class="form-group col-md-4">
                              <!-- <label style="color: #3F33FF">Mobile number</label> -->
                              <span> Mobile Number<a class="red-asterik">*</a></span>
                              <input type="text" [(ngModel)]="Mobile" class="form-control input-sm purpleInput" />
                            </div> 
                            <div class="form-group col-md-4">
                              <!-- <label style="color: #3F33FF">What can we help you with?</label> -->
                              <span> What can we help you with?<a class="red-asterik">*</a></span>
                              <textarea class="textarea" [(ngModel)]="Message" class="form-control input-sm purpleInput"></textarea>
                             
                            </div>
          
                            <div class="form-group col-md-8">
                              <re-captcha style="width: 100% !important;" (resolved)="resolved($event)" siteKey="{{getSiteKey()}}" ></re-captcha>
          
                          </div>
                          <br>
                          <div class="form-group col-md-8">
                            <input type="checkbox" style="height:20px;width:25px" name="terms-check" value="1" ([ngModel])="terms" [checked]="terms=='1'" (click)="ckeckTerms($event)" />
                            &nbsp;
                              <a href="https://www.cbrta.co.za/legal-and-privacy" class="opensans-bold-saffron-16px" target="_blank">By clicking the checkbox, you note our POPIA Processing Notices</a>
          
                            </div>

                    <br>
                          
                          <div class="submitbtn col-md-8">
                             <button type="submit"  (click)="submit()"
                             class="submit" style="color: #FFFFFF">Submit
                     </button>
                         </div>
                        </div>
                     

              </div>

              <div class="col-7" style="margin-top: 30px; margin-right: -25px;">
                
                  <div class="row ">
                    <div class="col-4"> <div class="group-133"></div></div>
                    <div class="col-8" style="
    margin-left: -50px;">
                      <span class="if-you-need-to-conta opensans-semi-bold-black-16px" style="font-weight: bold;margin: 6px;"><b>If you need to contact the Cross Easy helpdesk please use </b></span
                        ><br>
                        <span class="if-you-need-to-conta opensans-semi-bold-black-16px" style="font-weight: bold;margin: 6px;"><b>the information below:</b></span
                          >
                      <br>
                      <br>
                      
                      <div class="group-136 opensans-normal-black-16px">
                        <div class="helpdesk-container" style="margin: 6px;">
                          <p class="helpdesk-line-270-12-471-2121" >
                            <span class="opensans-normal-black-16px" style="font-weight: bold;"><b>   helpdesk line:</b> </span
                            ><span class="opensans-semi-bold-black-16px" style="font-weight: bold;"><b>  +27(0) 12 471 2121 </b></span>
                          </p>
                          <div class="helpdesk-email-helpdeskcbrtacoza" >
                            <span class="opensans-semi-bold-black-16px" style="font-weight: bold;"><b>helpdesk email:</b> </span
                            ><span class="opensans-semi-bold-black-16px" style="font-weight: bold;"><b>helpdesk@cbrta.co.za</b></span>
                          </div>
                        </div>
                        <br>
                        <p class="switchboard-27-0" style="margin: 6px;">
                          <span class="opensans-semi-bold-black-16px" style="font-weight: bold;"><b>Switchboard:</b> </span
                          ><span class="opensans-semi-bold-black-16px" style="font-weight: bold;"> <b>+27 (0)12 471 2000</b><br /></span
                          ><span class="opensans-semi-bold-black-16px" style="font-weight: bold;"><b>Permit applications and queries:</b> </span
                          ><span class="opensans-semi-bold-black-16px" style="font-weight: bold;"><b>permits@cbrta.co.za</b><br /></span
                          ><span class="opensans-semi-bold-black-16px"style="font-weight: bold;"><b>Fraud and corruption hotline:</b> </span
                          ><span class="opensans-semi-bold-black-16px" style="font-weight: bold;"><b>0800 701 701; ethics@cbrta.co.za</b><br /></span
                          ><span class="opensans-semi-bold-black-16px" style="font-weight: bold;"><b> Customer care:</b> </span
                          ><span class="opensans-semi-bold-black-16px"style="font-weight: bold;"><b>customercare@cbrta.co.za</b></span>
                        </p>
                    </div>
                  </div>
                 <br>
                 <br>
                 <br>
                 <div style="padding-bottom: 50px;">
                 <div class="row" style="margin-top: 35px;">  
                  <div col="6"><img class="image-14" src="../assets/img/image-14-1@2x.png" alt="image 14" /></div>
                  <div col="6"><img class="image-12" src="../assets/img/image-12-1@2x.png" alt="image 12" /></div>
                
                  <div class="overlap-group1">
                    <p class="surname-1 opensans-bold-white-14-6px" style="margin-top: 10px; margin-left: -345px;">
                      <span class="span0">Cross</span><span class="opensans-bold-white-14-6px">&nbsp;&nbsp;&nbsp;&nbsp; </span
                      ><span class="span2">Easy</span>
                      <p>
                      <span class="opensans-normal-white-5-7px"style="margin-top: 10px; margin-left: -345px;">Here, There, Everywhere</span>
                    </p>
                    <div class="ellipse-1-1"></div>
                  </div>
                  <div class="overlap-group2"style="margin-top: -20px; margin-left:-100px">
                    <div class="see-photos-1 opensans-semi-bold-white-10px" >
                      <span class="opensans-semi-bold-white-10px">See photos</span>
                    </div>
                  </div>
                  <img class="vector-4" style="margin-top: -200px; margin-left: 350px;" src="../assets/img/vector-4-11@2x.png" alt="Vector 4" />
                
            </div>
                 <br>
                  <div class="row" style="margin-top: -180px;"> 
                    <div class="flex-col-2"> <p class="physical-address-350 opensans-normal-black-16px">
                    <br>
                    <br>
                    <br>
                    <span class="opensans-bold-sapphire-20px">Physical address<br /></span
                    ><span class="span1"><br /></span
                    ><span class="opensans-normal-black-14px" style="font-weight: bold;" 
                      ><b>350 Witch-Hazel Avenue</b><br /><b>Eco Point Office Park</b><br /><b>Block A, Eco Park</b><br /><b>Centurion</b><br /><b>Pretoria</b></span
                    >
                  </p></div>
                <div class="flex-col-2">
                  <p class="physical-address-350 opensans-normal-black-16px">
                    <br>
                    <br>
                    <br>
                  <span class="opensans-bold-sapphire-20px" >Postal address<br /></span
                  >
                  <span class="span1"><br /></span>
                  <span class="opensans-normal-black-14px"style="font-weight: bold;"
                    ><b>PO Box 560</b><br /><b>Menlyn</b><br /><b>0063</b><br /><b>Pretoria</b> <br /><b>South Africa</b></span
                  >
                </p></div>
                </div>
              </div>
            </div>
          </div>



      </div>



  </div>

</div>
</div>
  <!-- <body style="margin: 0; width: 100vw;
  height: 100vh;background: #ffffff">
    
                
           
            </div>
            <div class="group-container">
              <div class="group-137">
                <div class="group-133"></div>
                <div class="flex-col-1">
                  
                </div>
              </div>
              <div class="group-139">
                <div class="flex-col-2">
                
            </div>
          </div>
        
      </div>
    </div>
  </body> -->



